export const page = async () => {
    
    document.querySelector<HTMLElement>('.container-game').style.height = "auto";

    if(window.innerWidth > 1350){
        document.querySelector<HTMLElement>('.container-game').style.padding = "45px 0 35px 0";
    }

    if(window.innerWidth > 520 && window.innerWidth < 1350){
        document.querySelector<HTMLElement>('.container-game').style.padding = "35px 0 25px 0";
    }

    // Mobile screens
    if(window.innerWidth <= 520){
        
        window.onload = () => {

            document.querySelector<HTMLElement>('.container-game').style.padding = "24px 0 13px 0";
            document.querySelector<HTMLElement>('#container-canvas').style.width = "auto";
            document.querySelector<HTMLElement>('#container-canvas').style.height = "fit-content";
        };
    }

    showQuestions();
}


const showQuestions = () => {
    let btnAnswer = document.querySelector('#btnAwnswer') as any;
    let btnFinish = document.querySelector('#btnFinish') as any;
    

    btnAnswer.addEventListener("click", (e:any) => {
        e.preventDefault();
        
        document.querySelector('.stepUno').classList.remove('question-active');
        document.querySelector('.containerQustion').classList.add('question-active');
        let questions = document.querySelectorAll('.popup-validation-beer') as any;
        let arrayQuestions = [...questions];
        arrayQuestions.map(function(e){
            if(e.id == btnAnswer.getAttribute('data-show')){
                e.classList.add('activeAnswer');
                
                selectAnswer();
            }
        });
    })

}
const selectAnswer = () => {
    let questions = document.querySelectorAll(".activeAnswer .containerOptions span") as any;

    for(let i = 0; i < questions.length; i++){
        questions[i].addEventListener("click", (e:any) => {
            noSelect();
            questions[i].classList.add('selectAnswer');
            questions[i].children[0].checked = true;
        })
    }

    const noSelect = () => {
        for(let i = 0; i < questions.length; i++){
            questions[i].classList.remove('selectAnswer');
            questions[i].children[0].checked = false;
        }
    }
    btnQuestionActive();
}
const btnQuestionActive = () => {
    let btn = document.querySelector(".activeAnswer .containerbtns a") as any;
    btn.addEventListener("click", (e:any) => {
        e.preventDefault();
        let spanSelected = e.target.closest('.containerPopup').children[1].children;
        let verifySpanSelected = [...spanSelected].find( (e:any) => e.classList.contains('selectAnswer'));
        if(!verifySpanSelected) {
            e.target.closest('.containerbtns').previousElementSibling.classList.remove('hidden');
            e.target.closest('.containerbtns').previousElementSibling.textContent = 'Debes seleccionar una respuesta';
            setTimeout(() => {
                e.target.closest('.containerbtns').previousElementSibling.classList.add('hidden');
            }, 3000);
            return;
        }
        sendAnswer();
    })
}

const sendAnswer = () =>{
    let AnswerQuestion = document.querySelector('.activeAnswer .selectAnswer') as any;
    let TitleQuestion = document.querySelector('.activeAnswer h2') as any;
    let idQuestion = document.querySelector('.activeAnswer') as any;
    let id = idQuestion.getAttribute('data-id');
    apiSendAnswers(TitleQuestion.innerHTML, AnswerQuestion.children[3].innerHTML, id, AnswerQuestion.children[0].id);
}

const apiSendAnswers = ($question:string, $answer:string, $idQuestion?:string, $idAnswer?:string) => {
    const API_URL = window.location.protocol+`//`+window.location.host+'/store-answer';
    const data = new FormData();
    data.append("question", $question);
    data.append("answer", $answer);
    data.append("question_id", $idQuestion);
    data.append("answer_id", $idAnswer);

    fetch(API_URL, {
        method: 'POST',
        body: data
    })
    .then((response) => response.json())
    .then((response) => {
        if(response.stored = true){
            document.querySelector('.containerQustion').classList.remove('question-active');
            document.querySelector('.containerCongrats').classList.add('question-active');
        }
    })
    .catch(function(error) {});
}

let play = false;
const showPopupWinner = () => {
    let playAudio = document.querySelector('#playWin') as any;
    if(!play){
        playAudio.play();
        play = true;
    }
    
    let btnPlay = document.querySelector('.popup-winner a') as any;
    btnPlay.addEventListener("click", (e:any) => {
        e.preventDefault();
        location.href = window.location.protocol+`//`+window.location.host+'/juegos/corona-juego/juega-y-gana';
    })
}